<template>
  <a @click="openOauthWindow">
    <img src="@/assets/images/linkedin_icon.png" alt="gmail icon" class="icon-resize">
  </a>
</template>
<script>
export default {
  props: {
    redirectUri: {
      type: String,
      default: "http://localhost:8080/linkedin"
    },
    clientId: {
      required: true,
      type: String
    },
    scope: {
      type: Array,
      default: [
        "r_liteprofile",
        "w_member_social",
        "r_emailaddress",
        "w_compliance",
        "r_compliance"
      ]
    },
    onSuccess: Function,
    state: {
      default: "foobar",
      type: String
    }
  },
  data() {
    return {
      popup: null
    };
  },
  computed: {
    getUrl() {
      const { redirectUri, clientId, scope, state } = this;
      // TODO: Support IE 11
      const scopeParam = scope ? `&scope=${encodeURI(scope)}` : "";
      const authLink = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}${scopeParam}&state=${state}`;
      return authLink;
    }
  },
  methods: {
    /* TODO: 
      1. Check state 
      2. Handle error codes
        user_cancelled_login
        user_cancelled_authorize
        error_description
    */
    receiveMessage(e) {
      if (e.origin === window.location.origin) {
        if (e.data.errorMessage && e.data.from === "Linked In") {
          this.onFailure(e.data);
          this.popup && this.popup.close();
        } else if (e.data.code && e.data.from === "Linked In") {
          this.onSuccess({ code: e.data.code });
          this.popup && this.popup.close();
        }
      }
    },
    openOauthWindow(e) {
      if (e) {
        e.preventDefault();
      }

      this.popup = window.open(this.getUrl, "_blank", "width=600,height=600");
      window.removeEventListener("message", this.receiveMessage, false);
      window.addEventListener("message", this.receiveMessage, false);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
